import React from "react";

export default function WidgetWrapper({ title, children, onRemove }) {
  return (
    <div style={{ border: "1px solid #e6e6e6", borderRadius: 6, background: "#fff", height: "100%", display: "flex", flexDirection: "column" }}>
      <div style={{ padding: "6px 8px", borderBottom: "1px solid #f2f2f2", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        <div style={{ fontWeight: 600 }}>{title}</div>
        <div>
          <button onClick={onRemove} aria-label="Remove widget">✕</button>
        </div>
      </div>
      <div style={{ padding: 8, overflow: "auto", flex: 1 }}>{children}</div>
    </div>
  );
}
